/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export interface KeyCodeData {
  code: string;
  keyCode: number;
  key: string;
}

export class KeyCode implements KeyCodeData {
  readonly code: string;
  readonly keyCode: number;
  readonly key: string;

  constructor(keyCode: KeyCodeData) {
    this.code = keyCode.code;
    this.keyCode = keyCode.keyCode;
    this.key = keyCode.key;
  }
}

export class KeyCodes {
  static readonly BACKSPACE: KeyCode = new KeyCode({ code: 'Backspace', keyCode: 8, key: 'Backspace' });
  static readonly TAB: KeyCode = new KeyCode({ code: 'Tab', keyCode: 9, key: 'Tab' });
  static readonly ENTER: KeyCode = new KeyCode({ code: 'Enter', keyCode: 13, key: 'Enter' });
  static readonly NUMPAD_ENTER: KeyCode = new KeyCode({ code: 'NumpadEnter', keyCode: 13, key: 'Enter' });
  static readonly ESC: KeyCode = new KeyCode({ code: 'Escape', keyCode: 27, key: 'Escape' });
  static readonly SPACE: KeyCode = new KeyCode({ code: 'Space', keyCode: 32, key: ' ' });
  static readonly PAGE_UP: KeyCode = new KeyCode({ code: 'PageUp', keyCode: 33, key: 'PageUp' });
  static readonly PAGE_DOWN: KeyCode = new KeyCode({ code: 'PageDown', keyCode: 34, key: 'PageDown' });
  static readonly END: KeyCode = new KeyCode({ code: 'End', keyCode: 35, key: 'End' });
  static readonly HOME: KeyCode = new KeyCode({ code: 'Home', keyCode: 36, key: 'Home' });
  static readonly LEFT: KeyCode = new KeyCode({ code: 'ArrowLeft', keyCode: 37, key: 'ArrowLeft' });
  static readonly UP: KeyCode = new KeyCode({ code: 'ArrowUp', keyCode: 38, key: 'ArrowUp' });
  static readonly RIGHT: KeyCode = new KeyCode({ code: 'ArrowRight', keyCode: 39, key: 'ArrowRight' });
  static readonly DOWN: KeyCode = new KeyCode({ code: 'ArrowDown', keyCode: 40, key: 'ArrowDown' });
  static readonly DELETE: KeyCode = new KeyCode({ code: 'Delete', keyCode: 46, key: 'Delete' });
  static readonly INSERT: KeyCode = new KeyCode({ code: 'Insert', keyCode: 46, key: 'Insert' });
}
